import { render, staticRenderFns } from "./BasicCardComponentLayout.vue?vue&type=template&id=68d78257&"
import script from "./BasicCardComponentLayout.vue?vue&type=script&lang=js&"
export * from "./BasicCardComponentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports